!function (t, e) {
  for (var r in e) {
    t[r] = e[r];
  }

  e.__esModule && Object.defineProperty(t, "__esModule", {
    value: !0
  });
}(exports, function () {
  "use strict";

  var t = {
    126: function _(t, e, r) {
      function n(t) {
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }

      function o(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function i(t, e, r) {
        return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
          var n = function (t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = c(t));) {
              ;
            }

            return t;
          }(t, e);

          if (n) {
            var o = Object.getOwnPropertyDescriptor(n, e);
            return o.get ? o.get.call(r) : o.value;
          }
        })(t, e, r || t);
      }

      function a(t, e) {
        return (a = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        })(t, e);
      }

      function s(t, e) {
        return !e || "object" !== n(e) && "function" != typeof e ? u(t) : e;
      }

      function u(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function c(t) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
      }

      var l = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
        void 0 === n && (n = r), Object.defineProperty(t, n, {
          enumerable: !0,
          get: function get() {
            return e[r];
          }
        });
      } : function (t, e, r, n) {
        void 0 === n && (n = r), t[n] = e[r];
      }),
          f = this && this.__setModuleDefault || (Object.create ? function (t, e) {
        Object.defineProperty(t, "default", {
          enumerable: !0,
          value: e
        });
      } : function (t, e) {
        t.default = e;
      }),
          p = this && this.__importStar || function (t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && l(e, t, r);
        }
        return f(e, t), e;
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var d = p(r(888)),
          y = r(773),
          h = r(804),
          v = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && a(t, e);
        }(p, t);
        var e,
            r,
            n,
            l,
            f = (n = p, l = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (l) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return s(this, t);
        });

        function p(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, p), (e = f.call(this, t)).state = {
            canvas: void 0,
            library: void 0
          }, e.loadCanvas = e.loadCanvas.bind(u(e)), e;
        }

        return e = p, (r = [{
          key: "destroy",
          value: function value() {
            this.state.library && (this.state.library.destroy(), this.setState({
              library: void 0
            }));
          }
        }, {
          key: "loadCanvas",
          value: function value(t) {
            var e = this;
            t && this.setState({
              canvas: t
            }, function () {
              var r = e.state.library;
              r && (r.canvas.loadCanvas(t), r.start());
            });
          }
        }, {
          key: "shouldComponentUpdate",
          value: function value(t) {
            return !h.isEqual(t, this.props);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.refresh(this.props);
          }
        }, {
          key: "forceUpdate",
          value: function value() {
            this.refresh(this.props), i(c(p.prototype), "forceUpdate", this).call(this);
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            var t;
            this.setState({
              library: this.buildParticlesLibrary(this.props.id, null !== (t = this.props.params) && void 0 !== t ? t : this.props.options)
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.destroy();
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
                e = t.width,
                r = t.height,
                n = t.className,
                o = t.canvasClassName,
                i = t.id;
            return d.default.createElement("div", {
              className: n,
              id: i
            }, d.default.createElement("canvas", {
              ref: this.loadCanvas,
              className: o,
              style: Object.assign(Object.assign({}, this.props.style), {
                width: e,
                height: r
              })
            }));
          }
        }, {
          key: "buildParticlesLibrary",
          value: function value(t, e) {
            try {
              if (void 0 === window) return;
            } catch (t) {
              return;
            }

            y.tsParticles.init();
            var r = new y.Container(null != t ? t : p.defaultProps.id, e);
            return this.props.container && (this.props.container.current = r), r;
          }
        }, {
          key: "refresh",
          value: function value(t) {
            var e,
                r = this,
                n = this.state.canvas;
            n && (this.destroy(), this.setState({
              library: this.buildParticlesLibrary(t.id, null !== (e = t.params) && void 0 !== e ? e : t.options)
            }, function () {
              r.loadCanvas(n);
            }));
          }
        }]) && o(e.prototype, r), p;
      }(d.Component);

      e.default = v, v.defaultProps = {
        width: "100%",
        height: "100%",
        options: {},
        style: {},
        id: "tsparticles"
      };
    },
    991: function _(t, e, r) {
      var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
        void 0 === n && (n = r), Object.defineProperty(t, n, {
          enumerable: !0,
          get: function get() {
            return e[r];
          }
        });
      } : function (t, e, r, n) {
        void 0 === n && (n = r), t[n] = e[r];
      }),
          o = this && this.__exportStar || function (t, e) {
        for (var r in t) {
          "default" === r || Object.prototype.hasOwnProperty.call(e, r) || n(e, t, r);
        }
      },
          i = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.Particles = void 0;
      var a = i(r(126));
      e.Particles = a.default, o(r(90), e), e.default = a.default;
    },
    804: function _(t) {
      t.exports = require("lodash");
    },
    773: function _(t) {
      t.exports = require("tsparticles");
    },
    90: function _(t) {
      t.exports = require("tsparticles/dist/Enums");
    },
    888: function _(t) {
      t.exports = require("react");
    }
  },
      e = {};
  return function r(n) {
    if (e[n]) return e[n].exports;
    var o = e[n] = {
      exports: {}
    };
    return t[n].call(o.exports, o, o.exports, r), o.exports;
  }(991);
}());